import { StyleSheet } from 'aphrodite';
import { THEME } from '../Theme/theme';

export const styleSheet = StyleSheet.create({
	popup: {
		width: 440,
		maxWidth: '100%',
		paddingLeft: THEME.spacing.xl,
		paddingRight: THEME.spacing.xl,
	},
	header: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: THEME.spacing.md,
		width: '100%',
		marginTop: THEME.spacing.xl,
	},
	warningIcon: {
		flexShrink: 0,
	},
	title: {
		textAlign: 'center',
	},
	description: {
		margin: 0,
		marginBottom: THEME.spacing.lg,
		textAlign: 'center',
	},
	buttonRow: {
		display: 'flex',
		width: '100%',
		alignItems: 'center',
		justifyContent: 'center',
		gap: THEME.spacing.md,
	},
});
